export const accountTypes = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    INVALID_TOKEN: 'INVALID_TOKEN',
    CHANGE_DYNAMICS_ID: 'CHANGE_DYNAMICS_ID',
    REMOVE_CUSTOMER_ID: 'REMOVE_CUSTOMER_ID'
};